<template>
    <div>
        <card-header title="Edit Registration Fee" icon="fa-pencil"/>

        <card-body>
            <rmc-discount-form :discount="discount"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
<!--                    <b-button type="is-warning is-outlined" size="is-small" @click=""><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Conference?</span></b-button>-->
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!discount.title || !discount.code || !discount.type || !discount.value"
                    ><i class="fas fa-check mr-2"></i>Save Discount
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import RmcConferenceForm from "@/cards/RMC/conferences/ConferenceForm";

    import {client as http} from '@/http_client';
    import RmcDiscountForm from "./DiscountForm";

    export default {
        components: {RmcDiscountForm, RmcConferenceForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                discount: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadFee: function() {
                this.$emit('loading', true);
                http.get('rmc/discounts/' + this.props.discountId, {force: true}).then(response => {
                    this.discount = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('rmc/discounts/' + this.props.discountId, {
                    id: this.discount.id,
                    title: this.discount.title,
                    code: this.discount.code,
                    type: this.discount.type,
                    value: this.discount.value
                }, {force: true}).then(response => {
                    this.$reloadCard('rmc-discounts');
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the discount.');
                    this.$emit('loading', false);
                });
            }
        },
        watch: {
            'props.confId': function() {
                this.dirty = null;
                this.loadFee();
            },
            'discount': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this discount? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadFee();
        }
    };
</script>
